import Title from '~/components/Modal/Title/Title';

export default Title;
